import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as prismicActions from '../redux/actions/prismicActions';
import PrismicReact from 'prismic-reactjs';
import { Button, Form, Input } from "reactstrap";
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody
} from "react-accessible-accordion";
import MetaTags from '../components/MetaTags';
// import Hero from '../components/Hero';
import InsiderForm from '../components/InsiderForm';
import LoadingOverlay from '../components/LoadingOverlay'
import htmlSerializer from '../plugins/htmlSerializer'

class BecomeInsider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      doc: null,
      notFound: false,
      pageContent: [],
      formSubmitted: false
    }

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  handleFormSubmit = (value) => {
      this.setState({formSubmitted: value});
  }

  componentWillMount() {
    this.findPage(this.props)
  }

  componentWillReceiveProps(props) {
    this.findPage(props)
  }

  findPage(props) {
    if(props.prismicData) {
      let doc = props.prismicData.results.find(result => result.type === 'become_insider'); 
      this.setState({
        doc
      },() => {
        this.formatPage(this.state.doc);
      })
      props.getActiveDoc(doc)
    }
  }


  formatPage(doc) {
    if(doc) {
      // Format faq info
      let mainColumnContent = PrismicReact.RichText.render(doc.data.main_column_content);
      // let heroTitle = PrismicReact.RichText.render(doc.data.body[0].primary.hero_title);
      // let hero = 
      //   <div className="hero-wrapper">
      //       <Hero 
      //         heroTitle={heroTitle}
      //       />
      //     <div className="container diagonal-texture-bg-wrap">
      //       <img src="/assets/images/diagonal-texture-bg.png" className="diagonal-texture-bg" aria-hidden="true" />
      //     </div>
      //   </div>
      
      let contact = 
        <div className="insider-form">
            <InsiderForm
              mailchimpListId="0fb8bc7a99"
              mailchimpListU="d331c46ec9c09b855a3ced40e"
              firstNamePlaceholder={doc.data.first_name_placeholder}
              lastNamePlaceholder={doc.data.last_name_placeholder}
              emailPlaceholder={doc.data.email_placeholder}
              postalCodePlaceholder={doc.data.postal_code_placehodler}
              subscribeBtnText={doc.data.button_text}
              errorMessage={doc.data.error_message}
              formContent={doc.data.form_content}
              successContent={doc.data.success_content}
              checkboxLabel={doc.data.checkbox_label}
              languageLabel={doc.data.preferred_language_label}
              englishLabel={doc.data.preferred_language_english_label}
              frenchLabel={doc.data.preferred_language_french_label}
              downloadText={doc.data.success_content[0].success_button_text}
              downloadLink={doc.data.success_content[0].success_link.url}
              onFormSubmit={this.handleFormSubmit}
            />
        </div>

      let pageContent = 
        <div>
          <div className="container main-container">
            <div className="become-insider-container">
              <div className="main-content">{mainColumnContent}</div>
              <div className="side-col">
                {contact}
              </div>
              <div className={this.state.formSubmitted ? "form-success-content show" : "form-success-content"}>

              </div>
              
            </div>
          </div>
        </div>

      this.setState({
        pageContent: pageContent
      });
    }
  }

  render() {
    if(this.state.doc) {
      window.document.querySelector('html').classList.add('ready');
      const document = this.state.doc

      return (
        <main data-wio-id={document.id} id={document.id} className={`page page-insider`}>
          {/* <AgeGate /> */}
          <MetaTags 
            title={`${this.state.doc.data.meta_title ? this.state.doc.data.meta_title : 'AltaVie'}`}
            description={`${this.state.doc.data.meta_description ? this.state.doc.data.meta_description : "Open your mind and find your state of mindfulness, enhanced by our low THC, high CBD strains of cannabis. At AltaVie, we're all about elevating the way you live."}`}
          />
          <section className="section-content">
            <div class="bg-container">
              <div class="bg-gradient"></div><div class="bg-pattern"></div>
            </div>
            {this.state.pageContent}
          </section>
        </main>
      )
    } 
    return <LoadingOverlay /> 
  }
}

const mapStateToProps = state => ({
  locale: state.global.locale,
  activeDoc: state.prismic.activeDoc,
  prismicCtx: state.prismic.prismicCtx,
  prismicData: state.prismic.prismicData,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { getActiveDoc: prismicActions.getActiveDoc, },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(BecomeInsider)




// WEBPACK FOOTER //
// ./src/pages/BecomeInsider.js